import { t } from '@/ui/i18n/i18n';
import { v4 as uuidv4 } from 'uuid';
import {
  INSPECTION_LIST_CONDITIONS,
  INSPECTION_CHECKBOX_CONDITIONS,
} from '@/_legacy/constants';
import { isEntityTypeOfResponseEnabled, isWordTemplateReportEnabled } from '@/ui/helpers/featureHelper';

export const generateHeaderPage = () => {
  const featureEnabled = isWordTemplateReportEnabled();

  const items = [
    {
      uuid: uuidv4(),
      ...(featureEnabled && { element_id: 'question1' }),
      title: t('checklist.prepared-by'),
      type: 'question',
      response_type: 'user_automatic',
      required: false,
      params: { automatic: true },
      check_conditions_for: [],
      categories: [],
    },
    {
      uuid: uuidv4(),
      ...(featureEnabled && { element_id: 'question2' }),
      title: t('checklist.conducted-at'),
      type: 'question',
      response_type: 'datetime_automatic',
      required: false,
      params: { automatic: true },
      check_conditions_for: [],
      categories: [],
    }
  ];

  if (isEntityTypeOfResponseEnabled()) {
    items.push({
      uuid: uuidv4(),
      ...(featureEnabled && { element_id: 'question3' }),
      title: t('common.entity-item'),
      type: 'question',
      response_type: 'entity_item',
      required: false,
      params: { automatic: false, multiple_selection: false },
      photos_allowed: true,
      issues_allowed: true,
      notes_allowed: true,
      check_conditions_for: [],
      categories: [],
      entity_types: [],
      entity_folders: [],
    });
  }

  return {
    uuid: uuidv4(),
    ...(featureEnabled && { element_id: 'page1' }),
    type: 'page',
    items,
    params: {
      header: true,
      collapsed: true,
    },
  };
};

export const logicConditionAcceptsEmptyValue = operator => {
  return [
    INSPECTION_LIST_CONDITIONS.NOT_EMPTY,
    INSPECTION_LIST_CONDITIONS.EMPTY,
    INSPECTION_CHECKBOX_CONDITIONS.IS_TRUE,
    INSPECTION_CHECKBOX_CONDITIONS.IS_FALSE,
  ].includes(operator);
};

export const getDefaultTitleSettings = () => {
  return {
    template_title: true,
    entity_item: false,
    conducted_by: false,
    conducted_at: false,
    submitted_id: false,
  };
};

export const getDefaultAssets = () => ({
  documents: [],
  images: [],
  videos: [],
  audios: []
});
